<template>
  <div class="already-receive-list">
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="分批申请单号:" prop="deliveryNum">
        <el-input v-model.trim="searchForm.deliveryNum" placeholder="请输入分批申请单号" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="masterContractNum">
        <el-input v-model.trim="searchForm.masterContractNum" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入合同编号" @blur="salaryChange" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="masterProjectName">
        <el-input v-model.trim="searchForm.masterProjectName" placeholder="请输入发货单号" />
      </el-form-item>
      <el-form-item label="申请日期:" prop="startTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div class="operate-btn-wrap">
      <!-- 导出功能 -->
      <el-button type="primary" @click="exPort()">
        导出
      </el-button>
    </div>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <!-- <el-table-column prop="StateClass" label="操作" width="90" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="removeApply(row)" v-if="row.processState ==1 && row.processState">
              撤销
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="deliveryNum" label="分批申请单号" align="left" width="150" fixed="left">
          <template v-slot="{row}">
            <el-button v-if="row.amountDisplayFlag" type="text" @click="numberClick(row)">
              {{ row.deliveryNum }}
            </el-button>
            <el-button v-else type="text" @click="numberClickTwo(row)">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterContractNum" label="合同编号" align="left" width="130" fixed="left">
          <template v-slot="{row}">
            <el-button v-if="row.amountDisplayFlag" type="text" @click="numberContract(row)">
              {{ row.masterContractNum }}
            </el-button>
            <el-button v-else type="text" @click="numberContractTwo(row)">
              {{ row.masterContractNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterProjectName" label="项目名称" align="left" min-width="150" />
        <el-table-column prop="receiptAddress" label="收货地址" align="left" min-width="150" />
        <el-table-column label="分批发货金额" align="right" width="130" header-align="left">
          <template v-slot="{row}">
            <span v-if="row.amountDisplayFlag">{{ row.partialInvoiceAmount }}</span>
            <span v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请日期" align="left" width="140" />
        <el-table-column prop="processStateStr" label="状态信息" min-width="90" align="left" />
        <el-table-column prop="invoiceNum" label="发货单号" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="deliverClick(row)">
              {{ row.invoiceNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="logistClick(row)">
              {{ row.logisticsNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="120" fixed="right">
          <!-- <template v-slot="{row}"> -->
          <template v-slot="{row}">
            <el-button v-if="row.processState === 1 ||row.processState === 7" type="text" @click="revokeHttp(row)">
              召回
            </el-button>
            <el-button v-if="row.processStateStr === '待付款'" type="text" @click="distribution(row)">
              分配
            </el-button>
          </template>
          <!-- </template> -->
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog
      title="召回原因"
      :visible.sync="dialogVisible"
      width="360px"
      @close="revokeDialogClose"
    >
      <el-input
        v-model="deleteReason"
        type="textarea"
        placeholder="请输入召回原因"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="mini" type="text" @click="dialogVisible = false">取消</el-button> -->
        <el-button type="primary" size="mini" :loading="isBackLoading" @click="handleDeleteDebit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="发货产品清单" :visible.sync="receiptProductVisible" width="800px">
      <delivery-receipt-product-list
        v-if="receiptProductVisible"
        :receipt-number="receiptNumber"
        :contract-code="contractCode"
        :order-number="orderNumber"
      />
    </el-dialog>
    <el-dialog title="回单信息" :visible.sync="receiptVisible" width="700px">
      <receipt-list v-if="receiptVisible" :receipt-form="receiptForm" :is-show="isShow" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="receiptVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="exportUrl" target="_blank" />
    <partShipCheck :id="partId" :dialog-form-visible="dialogFormVisible" @on-status-dialog="updataDialogFormVisible" />
    <partShipCheckTwo :id="partId" :dialog-form-visible="dialogFormVisibleTwo" @on-status-dialog="updataDialogFormVisibleTwo" />
    <deliverGoodsNumber :dialog-form-visible-deliver="dialogFormVisibleDeliver" :form="formNum" @on-status-dialog="updataDialogFormVisibleDeliver" />
    <logisticsNumber :dialog-form-visible-logist="dialogFormVisibleLogist" :form="formNum" @on-status-dialog="updataDialogFormVisibleLogist" />
  </div>
</template>

<script>
import { appliedPartialInvoice, revokeApply, selectExportPartialInvoice, checkSplitAndFreightPayType, getContractInfoByDocumentId } from '@/API/index.js';
// import API from '@/API/international.js';
import deliveryReceiptProductList from './deliveryReceiptProductList';
import receiptList from './receiptList';
import partShipCheck from '../../partShipCheck';
import partShipCheckTwo from '../order/partShipCheck';
import deliverGoodsNumber from '../../partShipCheck/deliverGoodsNumber';
import logisticsNumber from '../../partShipCheck/logisticsNumber';
import eventBus from '@/libs/eventBus.js';
export default {
  name: 'AlreadyReceiveList',
  data () {
    return {
      tableLoading: false,
      isBackLoading: false,
      receiptProductVisible: false,
      // 定义组件
      dialogFormVisible: false,
      dialogFormVisibleTwo: false,
      dialogFormVisibleDeliver: false,
      dialogFormVisibleLogist: false,
      exportUrl: '',
      formNum: {},
      searchForm: {
        deliveryNum: '',
        masterContractNum: '',
        masterProjectName: '',
        startTime: '',
        endTime: ''
      },
      tableData: [],
      partId: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      receiptNumber: '',
      contractCode: '',
      orderNumber: '',
      receiptVisible: false,
      receiptForm: {},
      isShow: false,
      // 召回参数
      dialogVisible: false,
      deleteReason: '',
      revokedata: {}

    };
  },
  components: {
    deliveryReceiptProductList,
    receiptList,
    partShipCheck,
    deliverGoodsNumber,
    logisticsNumber,
    partShipCheckTwo
  },
  methods: {
    // blur
    salaryChange (e) {
      this.searchForm.masterContractNum = (e.target.value || '').trim();
    },
    initData () {
      this.tableLoading = true;
      let params = {
        deliveryNum: this.searchForm.deliveryNum,
        masterContractNum: this.searchForm.masterContractNum,
        masterProjectName: this.searchForm.masterProjectName,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        pageSize: this.page.pageSize,
        pageIndex: this.page.currentPage
      };
      appliedPartialInvoice(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableLoading = false;
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
          this.tableData = json.data.list;
          this.tableData.forEach((item) => {
            this.$set(item, 'textarea', '');
          });
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs['searchForm'].resetFields();
      this.searchForm.endTime = '';
      this.page.currentPage = 1;
      this.initData();
    },
    doSearch () {
      this.page.currentPage = 1;
      this.initData();
    },
    // 导出按钮
    // exPort () {
    // this.exportUrl = `${API.defaults.baseURL}/partialInvoice/selectExportPartialInvoice`;
    // this.$nextTick(() => {
    //   this.$refs.downTag.click();
    // });
    // ;
    exPort () {
      // this.submitLoading = true;
      selectExportPartialInvoice().then((res) => {
        // this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '分批发货' + new Date().toLocaleString() + '.xlsx';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {});
    },
    // },
    // 撤销按钮
    // removeApply (row) {
    //   this.$confirm('是否撤销申请?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     // 调用撤销接口  查看返回状态
    //     this.revokeHttp(row.id);
    //   });
    // },
    // dialog 关闭
    revokeDialogClose () {
      this.deleteReason = '';
    },
    handleDeleteDebit () {
      let row = this.revokedata;
      if (this.deleteReason === '') {
        this.$message.error('请输入召回原因');
        return;
      }
      this.isBackLoading = true;
      revokeApply({ 'id': row.id, 'approvalOpinion': this.deleteReason }).then((res) => {
        let json = res.data;
        // this.$refs.gridTable.doClose();
        if (json.status === '200') {
          this.isBackLoading = false;
          this.$message({
            type: 'success',
            message: '召回成功 !'
          });
          this.dialogVisible = false;
          this.initData();
        }
      }).catch(() => {
        this.isBackLoading = false;
      });
    },
    // 撤销接口
    revokeHttp (row) {
      let parmas = { id: row.id };
      checkSplitAndFreightPayType(parmas).then((res) => {
        let json = res.data;
        if (json.data) {
          this.$confirm('此单运费差价使用返利支付，召回时此单关联的其他发货单将全部召回', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.revokedata = row;
            this.dialogVisible = true;
          }).catch(() => {
          });
        } else {
          this.revokedata = row;
          this.dialogVisible = true;
        }
      }).catch(() => {
        this.revokedata = row;
        this.dialogVisible = true;
      });
    },
    distribution (row) {
      this.$router.push({ name: 'BatchBase', query: row });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = '实际结算金额';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = '未发货数量';
        }
      });
      return sums;
    },

    detailProductList (row) {
      this.receiptProductVisible = true;
      this.receiptNumber = row.ReceiptNumber;
      this.contractCode = row.ContractNumber;
      this.orderNumber = row.ERPNumber;
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    pickerOptions () {

    },
    toReceiptList (row) {
      this.receiptVisible = true;
      this.receiptForm = row;
    },
    numberClick (row) {
      this.partId = row.id;
      this.dialogFormVisible = true;
    },
    numberClickTwo (row) {
      this.partId = row.id;
      this.dialogFormVisibleTwo = true;
    },
    numberContract (row) {
      // this.$router.push({ name: 'ContractInfo', params: { contractNum: row.masterContractNum, id: row.id, masterProjectName: row.masterProjectName } });
      this.$router.push({ name: 'ContractInfo', params: { contractNum: row.masterContractNum }, query: { id: row.masterContractId, masterProjectName: row.masterProjectName } });
    },
    numberContractTwo (row) {
      // this.$router.push({ name: 'ContractInfo', params: { contractNum: row.masterContractNum }, query: { id: row.masterContractId, masterProjectName: row.masterProjectName } });
      getContractInfoByDocumentId(row.documentId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data.contractNum) {
            this.$router.push({
              name: 'logistics',
              params: {
                contractNum: json.data.contractNum
              },
              query: { id: json.data.id, masterProjectName: json.data.projectName }
            });
          } else {
            this.$notify.error({
              message: '暂未生成合同，请稍后再试。'
            });
          }
        }
      }).catch(() => {

      });
    },
    //
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    updataDialogFormVisibleTwo (val) {
      this.dialogFormVisibleTwo = val;
    },
    // 组件事件
    updataDialogFormVisibleDeliver (val) {
      this.dialogFormVisibleDeliver = val;
    },
    // 组件事件
    updataDialogFormVisibleLogist (val) {
      this.dialogFormVisibleLogist = val;
    },
    deliverClick (row) {
      this.formNum = row;
      this.dialogFormVisibleDeliver = true;
    },
    logistClick (row) {
      this.formNum = row;
      this.dialogFormVisibleLogist = true;
    },
    revoke (row) {
      // this.dialogFormVisibleLogist = true;
    }

  },
  mounted () {
    this.initData();
    eventBus.$on('changescom', () => {
      this.initData();
    });
  }
};
</script>

<style scoped>

</style>
